export enum ConfigurationTypeEnum {
    Single = "S",
    List = "L",
    Range = "R",
    Matrix = "M",
}